import { ApiConstants } from "../utils/ApiConstants";
import axios from "axios";

export class JwtVerify {
  static jwtVerify = async (microformToken: string, captureContext: string) => {
    return await axios.post(ApiConstants.jwtVerify, {
      microformToken,
      captureContext,
    });
  };
}
